import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { billingExplorerSetupVisualizationPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupVisualizationPropertyByKeySelector";
import { billingExplorerViewVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerViewVisualizationChangeThunk";
import { SwitchWithTypography } from "@/components/SwitchWithTypography";

export const BillingExplorerWidgetVisualizationDisplayForecast: FC = () => {
  const dispatch = useAppDispatch();
  const displayForecast: boolean = !!useAppSelector(
    billingExplorerSetupVisualizationPropertyByKeySelector("display_forecast"),
  );

  const changeHandler = useCallback(
    (checked: boolean) => {
      dispatch(
        billingExplorerViewVisualizationChangeThunk({
          display_forecast: checked,
        }),
      );
    },
    [dispatch],
  );

  return (
    <SwitchWithTypography
      variant="filled"
      checked={displayForecast}
      onChange={changeHandler}
      title="Display Forecast"
      infoTooltipTitle={infoTooltipTitle}
    />
  );
};

const infoTooltipTitle =
  "Displays forecast data as bars on the chart. Forecasts are only shown when the selected date range is Month-to-Date (MTD) or Quarter-to-Date (QTD) and Date Granularity is Daily.";
